module.exports = __webpack_public_path__ + "static/media/help-header-04@3x.6504634b.png";